import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }) {
    const { user, ready } = useAuth();
    const location = useLocation();
    const navState = useMemo(() => ({ from: location }), [location]);

    if (!ready) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="text-muted-foreground">Cargando…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={navState} replace />;
    }
    return children;
}
